module.exports = __webpack_public_path__ + "img/1480601897.e4e470be.jpg";